exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdf-view {\n  width: 100%;\n}\n\n.pdf-view canvas {\n  width: 100%;\n}\n\n.pdf-view_with-border {\n  border: 2px solid #0d3a52;\n  box-sizing: content-box;\n}\n\n.pdf-view__open-link {\n  text-decoration: underline;\n}\n\n", ""]);

// exports
